import React, { useEffect } from 'react';
import { Button } from './Button';
import './ui.scss';

export const Drawer = ({
  show,
  onClose,
  title,
  children,
  position = 'right',
}) => {
  useEffect(() => {
    if (!show) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="builder-ui-drawer-overlay" onClick={onClose} role="presentation">
      <aside
        className={`builder-ui-drawer builder-ui-drawer--${position}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="builder-drawer-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="builder-ui-drawer__header">
          <h2 id="builder-drawer-title" className="builder-h2">{title}</h2>
          <Button variant="ghost" icon={<span aria-hidden="true">×</span>} aria-label="Close" onClick={onClose} />
        </div>
        <div className="builder-ui-drawer__body">{children}</div>
      </aside>
    </div>
  );
};

export default Drawer;
